import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"

export const AccountingRuleFormType = {
  OTHER: 'OTHER'
}

export default function Accounting({ children }) {
  return (
    <div>
      <CustomPageHeader icon='money' text='Accounting' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/index.js